export default __webpack_public_path__ + "static/media/adur-worthing.4ccdcc90.svg";